import { CustomPageHeader, Text } from '@src/components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CurrentContent from './CurrentAccount';

const CurrentAccount = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [dispatch]);

    return (
        <CustomPageHeader
            data-testid="current-account"
            title={<Text t="currentAccountReport" />}
            showBreadCrumb
            showHelpButton
            routes={['Ticket Market', 'Raporlar']}
        >
            <CurrentContent />
        </CustomPageHeader>
    );
};

export default CurrentAccount;
